import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubjectMobile } from "../../../Pages/SubjectMobile/ISubjectMobile";

export const AddSubjectMobileSlice = createSlice({
  name: "AddSubjectMobileSlice",
  initialState: {} as IReduxState<ISubjectMobile>,
  reducers: {
    addSubjectMobile: (state, _: PayloadAction<ISubjectMobile>) => {
      state.isLoading = true;
    },
    successaddSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSubjectMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSubjectMobile,
  failureaddSubjectMobile,
  successaddSubjectMobile,
  clearAddSubjectMobileResponse,
} = AddSubjectMobileSlice.actions;

export default AddSubjectMobileSlice.reducer;
